document.addEventListener('turbolinks:load', function() {
    const booksSearchInput = document.getElementById('books_search');
    const booksSearchForm = document.getElementById('books_search_form');
    const booksSearchFilters = document.querySelectorAll("input[data_scope='books_search_filter']");

    if (booksSearchInput === null) return;

    booksSearchInput.addEventListener('input', triggerBooksSearch);
    booksSearchFilters.forEach((filter) => {
        filter.addEventListener('click', triggerBooksSearch);
    });

    function triggerBooksSearch() {
        booksSearchForm.requestSubmit();
    }
});
